// extracted by mini-css-extract-plugin
export default {"wrapper":"component-styles_wrapper__oiI7s"};